export * from './SignatureBuilder';

import * as cryptoPro from 'crypto-pro-web/dist/crypto-pro-web.min';

export async function isValidSystemSetup() {
	return cryptoPro.isValidSystemSetup();
}

export async function getUserCertificates() {
	return cryptoPro.getUserCertificates();
}

export async function createSignature(thumbprint, messageHash) {
	return cryptoPro.createDetachedSignature(
		thumbprint,
		await cryptoPro.createHash(messageHash)
	);
}
